"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMsal = void 0;
var tslib_1 = require("tslib");
var msal_browser_1 = require("@azure/msal-browser");
var MsalService_1 = require("./MsalService");
/**
 * Adds MSAL, creates a public client application, and handles the sign-in redirect. See https://devblogs.microsoft.com/azure-sdk/vue-js-user-authentication/
 *
 * @param msalConfiguration the MSAL configuration. For example:
    {
        auth: {
            authority: process.env.VUE_APP_AAD_AUTHORITY,
            clientId: process.env.VUE_APP_AAD_CLIENT_ID,
            redirectUri: process.env.VUE_APP_AAD_REDIRECT_URI,
            knownAuthorities: [process.env.VUE_APP_AAD_AUTHORITY]
        },
        cache: { cacheLocation: process.env.VUE_APP_AAD_CACHE_LOCATION }
    };
 * @param policyConfig the policy configuration. For example:
   {
        signUpSignIn: {
            authority: process.env.VUE_APP_AAD_AUTHORITY,
            scopes: process.env.VUE_APP_API_SCOPES.split(" ")
        },
        editProfile: {
            authority: process.env.VUE_APP_AAD_EDIT_PROFILE_AUTHORITY,
            scopes: signUpSignIn.scopes
        },
        resetPassword: {
            authority: process.env.VUE_APP_AAD_RESET_PASSWORD_AUTHORITY,
            scopes: signUpSignIn.scopes
        }
    }
 * @param handleSignInRedirect handler called when we're being redirected back from the AAD login page or when refreshing the token.
 * @param service the MSAL service
 * @returns the MSAL service
 */
function useMsal(msalConfigurationOrService, policyConfiguration, handleSignInRedirect) {
    return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
        var msalConfiguration, service;
        return (0, tslib_1.__generator)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    msalConfiguration = null;
                    service = null;
                    // function overloads in Typescript are interesting - see https://www.typescriptlang.org/docs/handbook/2/functions.html#function-overloads
                    if (msalConfigurationOrService !== undefined &&
                        policyConfiguration !== undefined &&
                        handleSignInRedirect !== undefined) {
                        msalConfiguration = msalConfigurationOrService;
                    }
                    else {
                        service = msalConfigurationOrService;
                    }
                    if (!service &&
                        msalConfiguration &&
                        policyConfiguration &&
                        handleSignInRedirect) {
                        setLoggerOptions(msalConfiguration);
                        service = new MsalService_1.MsalService(msalConfiguration, policyConfiguration, handleSignInRedirect);
                    }
                    if (!service) return [3 /*break*/, 2];
                    return [4 /*yield*/, service.handleSignInRedirect()];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2: throw new Error("Invalid MSAL configuration");
                case 3: return [2 /*return*/, service];
            }
        });
    });
}
exports.useMsal = useMsal;
/**
 * Sets the MSAL logger options, if not already set.
 * See https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 * @param msalConfiguration the MSAL configuration.
 */
function setLoggerOptions(msalConfiguration) {
    if (!msalConfiguration.system) {
        msalConfiguration.system = {};
    }
    if (!msalConfiguration.system.loggerOptions) {
        msalConfiguration.system.loggerOptions = {
            loggerCallback: function (level, message, containsPii) {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case msal_browser_1.LogLevel.Error:
                        console.error(message);
                        return;
                    case msal_browser_1.LogLevel.Info:
                        console.info(message);
                        return;
                    case msal_browser_1.LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case msal_browser_1.LogLevel.Warning:
                        console.warn(message);
                        return;
                }
            },
            piiLoggingEnabled: false
        };
    }
}
//# sourceMappingURL=useMsal.js.map